import {getUuid} from "../http/service";
import {INVALID_UUID, stateObject} from "../utils/constants";
import {useState, useEffect} from 'react';
import swal from "../utils/swal";
import Strings from "../Lang/strings";
import {useHistory} from "react-router-dom";
import {fullAddressKeys} from "../utils/helper";

const useValidateState = (uuid) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [data, setData] = useState(stateObject);
    const [schedule, setSchedule] = useState();
    let history = useHistory();

    useEffect(() => {
        getUuid(uuid).then(onValidateStateSuccess).catch(onValidateStateFailed)
    }, []);
    const onValidateStateSuccess = (response) => {

        if (response.status === 204) { //order completed
            history.push({
                pathname: "/completed",
                state: {completed: true}

            })
        }
        const responseData = response.data;
        window.get = response.data;

        //CHECK IF CANCELED
        if (responseData.canceled) {
            swal(Strings.orderCanceled)
                .then(_ => document.location.replace('/'))
            return;
        }
        let dataAfterValidate = {};
        for (const key in data) {
            if (responseData[key]) {
                dataAfterValidate[key] = responseData[key];
            } else {
                dataAfterValidate[key] = key === "location" ? null : data[key];
            }
        }
        dataAfterValidate["url_id"] = uuid;
        dataAfterValidate["locked"] = responseData.locked;
        setData(dataAfterValidate);
        //current

        if (objHas(responseData, [...fullAddressKeys, "expected_time", "expected_date"])) {
            setCurrentStep(3);
        } else if (objHas(responseData, [...fullAddressKeys])) {
            setCurrentStep(2)
        } else {
            setCurrentStep(1);
        }
    }
    const onValidateStateFailed = (e) => {
        if (e.isGeneric) {
            return;
        }
        const failedStatus = e.response.status;
        if (failedStatus === 422) {
            const failedMsg = e.response.data.detail[0].msg;
            if (failedMsg === INVALID_UUID) {
                return document.location.replace('/');
            }
        }
        if (failedStatus === 404) {
            return document.location.replace('/');

        }
        console.log("unknown error", e);
        swal("unknown error when getting your progress");
    }


    const dataChangeHandler = (name, value) => {
        setData(prevState => ({...prevState, [name]: value}));
    };

    const objHas = (object, keys) => {
        let has = 0;
        keys.map((key) => {
            if (object[key]) {
                has++;
            }
        })
        return keys.length === has;
    }

    const isStateHasFullAddress = objHas(data, [...fullAddressKeys]);

    return {
        data,
        dataChangeHandler,
        currentStep,
        setCurrentStep,
        isStateHasFullAddress,
        schedule,
        setSchedule
    }

}


export default useValidateState;
